'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useState } from 'react';
type ConfirmationButton = {
  label: string;
  form?: string;
  type?: 'submit' | 'button' | 'reset';
  onClick?: () => Promise<void> | void;
};
export type ConfirmationDialog = {
  description?: string;
  children?: React.ReactNode;
  primaryButton: ConfirmationButton;
  secondaryButton?: ConfirmationButton;
  noPadding?: boolean;
  title: string;
  variant?: 'default' | 'destructive';
};
const useLocalConfirmationDialog = () => {
  const $ = _c(7);
  const [confirmationDialog, setConfirmationDialog] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = nextConfirmationDialog => {
      setConfirmationDialog(nextConfirmationDialog);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const open = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setConfirmationDialog(null);
      document.body.style.pointerEvents = "";
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hide = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsProcessing(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const startProcessing = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsProcessing(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const stopProcessing = t3;
  let t4;
  if ($[4] !== confirmationDialog || $[5] !== isProcessing) {
    t4 = {
      confirmationDialog,
      open,
      hide,
      startProcessing,
      stopProcessing,
      isProcessing
    };
    $[4] = confirmationDialog;
    $[5] = isProcessing;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default useLocalConfirmationDialog;